import { render, staticRenderFns } from "./SelectTenancy.vue?vue&type=template&id=89fa9734&"
import script from "./SelectTenancy.vue?vue&type=script&lang=ts&"
export * from "./SelectTenancy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports